import { registerSuperPropertiesOnce } from '@hbf/analytics';

const FBP_KEY = 'fbp';

/**
 * FBC is a parameter of facebook which needs to be sent with every event. This parameter is then used by facebook
 * to advertise better and effectively manage the campaigns
 */
export function storeFBPInSuperProperties(): void {
  try {
    const randomNumber = Math.random() * 10 ** 15;

    registerSuperPropertiesOnce({
      [FBP_KEY]: `fb.1.${Date.now()}.${Math.floor(randomNumber)}`,
    });
  } catch {
    // ignore
  }
}
